import React, { useEffect, useState } from "react";
import { Container, Col, Row, Button, Dropdown, DropdownButton, Modal, Form, Table, InputGroup, Badge, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import AdminNav from '../../components/adminnav/AdminNav';
import { useImageContext } from "../../hooks/useImageContext";
import { getImageUrl } from "../../helpers/images";
import { useAuthContext } from "../../hooks/useAuthContext";
import { getAge } from "../../helpers/dates";
import { getSmallNumber } from "../../helpers/stats";
import { apiCall, PageScroller } from "../../helpers/api";
import { getFilter, setFilter } from '../../helpers/filters'
import { Link } from "react-router-dom"
import AlertModal from "../../components/alerts/alert";
import searchBlue from './../../images/search-blue.svg'
import { getRatingPill } from "../../helpers/status";
import { getIndustries, getCountries, getCounties, getStates } from "../../helpers/dropdowns";
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import FullPageSpinner from "../../components/spinner/FullPageSpinner";
import './Influencers.css';
import Topbar from "../../components/topbar/Topbar";
import settings from './../../images/settings.svg';
import plus from './../signup/plus.svg';
import minus from './../signup/minus.svg';
import cancel from './../signup/cancel.svg';
const interests = getIndustries()

export default function Influencers() {  
  const [showNewInfluencerModal, setShowNewInfluencerModal] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [ activeButton, setActiveButton ] = useState(null);
  const { providers } = useImageContext();
  const { currentProfile } = useAuthContext();
  const [influencers, setInfluencers] = useState([]);
  const [availableQuestions, setAvailableQuestions] = useState({})
  const [newInfluencerData, setNewInfluencerData] = useState({
      "interests":"",
      "primaryInterest":"",
      "gender":"Female",
      "phoneNumber":"",
      "country":"",
      "email":"",
      "active":true,
      "sendPasswordReset":true,
      "createUser":false,
      "password":"",
      "passwordConfirm":"",
      "firstName":"",
      "lastName":""
  })
  const [influencerFilters, setInfluencerFilters] = useState({"states":[],"lastLogin":"","primaryInterests":[],"interests":[],"genders":[],"ages":[],"referred":[],"followers":0,"followersNone":"no","engagementRate":0,"search":"","countries":[],"counties":[],"statesUS":[],"cities":[],"ratings":[]});
  const [showAlert, setAlert] = useState({"display":"toast","visible":false,"title":"","content":""});
  const [pageStats, setPageStats] = useState({})
  const [specifyGender, setSpecifyGender] = useState(false);
  const countries = getCountries()
  const counties = getCounties()
  const statesUS = getStates()
  const [updateCounter, setUpdateCounter] = useState(0)
  const animatedComponents = makeAnimated();
  const [ notificationModal, setNotificationModal ] = useState({"visible":false,"title":"","message":"","target":"All","customTargets":[]})

  useEffect(() => {
    if (getFilter("influencer")) {
      setInfluencerFilters(JSON.parse(getFilter("influencer")))
    }
  }, []);

  const loginAsInfluencer = async (influencerID) => {
    setActiveButton("impersonate")
    var response = await apiCall("impersonate",{ "method" : "POST", "data" : {"id":influencerID,"type":"influencers","returnPage":window.location.pathname} });
    if (response["success"]){
      sessionStorage.removeItem("browsewallState")
      window.location.href="/Home";
    }
    else {
      setAlert({"display":"toast","visible":true,"title":"Failed to login as influencer","content":response["failure"]["error"],"className":"bg-danger text-background"})
    }
    setActiveButton(null)
  };

  const downloadInfluencers = async () => {
    setActiveButton("downloadInfluencers")
    var response = await apiCall(`admin/influencerListDownload`,{ "method" : "POST", "data" : {"filter": influencerFilters}, isFile:true });
    if (response["success"]){
      setAlert({"display":"toast","visible":true,"title":"Influencer List Downloaded","content":"Please check your downloads folder","className":"bg-success text-background"})
    }
    else {
      setAlert({"display":"toast","visible":true,"title":"Failed to download influencer list","content":response["failure"]["error"],"className":"bg-danger text-background"})
    }
    setActiveButton(null)
  }

  const disableInfluencer = async (influencerID) => {
    var response = await apiCall(`admin/disableUser`,{ "method" : "POST", "data" : {"id":influencerID,"type":"influencer"} });
    if (response["success"]){
      setAlert({"display":"toast","visible":true,"title":"Influencer disabled","content":"Influencer successfully disabled","className":"bg-success text-background"})
      for (var x in influencers) {
        if (influencers[x]["_id"] === influencerID) {
          influencers[x]["active"] = false;
          setInfluencers([...influencers]);
          break
        }
      }
    }
    else {
      setAlert({"display":"toast","visible":true,"title":"Failed to disable influencer","content":response["failure"]["error"],"className":"bg-danger text-background"})
    }
  }

  const enableInfluencer = async (influencerID) => {
    var response = await apiCall(`admin/enableUser`,{ "method" : "POST", "data" : {"id":influencerID,"type":"influencer"} });
    if (response["success"]){
      setAlert({"display":"toast","visible":true,"title":"Influencer enabled","content":"Influencer successfully enabled","className":"bg-success text-background"})
      for (var x in influencers) {
        if (influencers[x]["_id"] === influencerID) {
          influencers[x]["active"] = true;
          setInfluencers([...influencers]);
          break
        }
      }
    }
    else {
      setAlert({"display":"toast","visible":true,"title":"Failed to enable influencer","content":response["failure"]["error"],"className":"bg-danger text-background"})
    }
  }

  function updateNewInfluencerData(props){
    var tempInfluencerData = newInfluencerData;
    if (["active"].includes(props.target.id)){
        if (props.target.value == 1){
          tempInfluencerData[props.target.id] = true
        }
        else {
          tempInfluencerData[props.target.id] = false
        }
    }
    else if (props.target.id == "gender" || props.target.id == "specificGender" ){
      if (["Male","Female","Prefer not to say"].includes(props.target.value)){
        setSpecifyGender(false)
      }
      else {
        setSpecifyGender(true)
      }
      tempInfluencerData[props.target.id] = props.target.value
    }
    else { 
      tempInfluencerData[props.target.id] = props.target.value
    }
    setNewInfluencerData(tempInfluencerData)
    setUpdateCounter(updateCounter+1)
  }

  async function submitNewInfluencer(){
    var influencerData = newInfluencerData;
    if (specifyGender){
      influencerData["gender"] = influencerData.specificGender
    } 
    var response = await apiCall('influencer',{ "method" : "POST", "data" : newInfluencerData });
    if (response["success"]){
        setAlert({"display":"toast","visible":true,"title":"Influencer Created","content":`${newInfluencerData.firstName} ${newInfluencerData.lastName} Created Successfully`,"className":"bg-success text-background"})
        setShowNewInfluencerModal(false)
        setNewInfluencerData({
          "interests":"",
          "primaryInterest":"",
          "gender":"Female",
          "phoneNumber":"",
          "dob":"",
          "country":"",
          "email":"",
          "active":true,
          "sendPasswordReset":true,
          "createUser":false,
          "password":"",
          "passwordConfirm":"",
          "firstName":"",
          "lastName":""
        })
    }
    else if (response["failure"]) {
        setAlert({"display":"toast","visible":true,"title":"Could not create influencer","content":response["failure"]["error"],"className":"bg-danger text-background"})
    }
  }

  const handleFilterUpdate = (value,added,type,delay=0) => {
    var filters = influencerFilters;
    if (type == "reset"){
      filters = {"states":[],"lastLogin":"","primaryInterests":[],"interests":[],"genders":[],"ages":[],"referred":[],"followers":0,"followersNone":"no","engagementRate":0,"search":"","countries":[],"counties":[],"statesUS":[],"cities":[],"ratings":[]}
    }
    else if (type == "states"){
      if (added) { filters.states.push(value) }
      else { filters.states = influencerFilters.states.filter(function(state) { return state != value })}
    }
    else if (type == "lastLogin"){
      if (added) { filters.lastLogin = value }
      else { filters.lastLogin = "" }
    }
    else if (type == "primaryInterests"){
      if (added) { filters.primaryInterests.push(value) }
      else { filters.primaryInterests = influencerFilters.primaryInterests.filter(function(interest) { return interest != value })}
    }
    else if (type == "interests"){
      if (added) { filters.interests.push(value) }
      else { filters.interests = influencerFilters.interests.filter(function(interest) { return interest != value })}
    }
    else if (type == "genders"){
      if (added) { filters.genders.push(value) }
      else { filters.genders = influencerFilters.genders.filter(function(gender) { return gender != value })}
    }
    else if (type == "ratings"){
      if (added) { filters.ratings.push(value) }
      else { filters.ratings = influencerFilters.ratings.filter(function(rating) { return rating != value })}
    }
    else if (type == "ages"){
      if (added) { filters.ages.push(value) }
      else { filters.ages = influencerFilters.ages.filter(function(age) { return age != value })}
    }
    else if (type == "followers" || type == "engagementRate" ){
      filters[type] = value
    }
    else if (type == "followersNone" ){
      if (added) {
        filters[type] = "yes"
      } else {
        filters[type] = "no"
      }
    }
    else if (type == "referred" ){
      if (added) { filters.referred.push(value) }
      else { filters.referred = influencerFilters.referred.filter(function(referrerState) { return referrerState != value })}
    }
    else if (type == "search") {
      filters.search = value.target.value.toLowerCase();
    }
    else if (type == "countries"){
      filters.countries = value.map(countries => countries.value)
    }
    else if (type == "counties"){
      filters.counties = value.map(county => county.value)
    }
    else if (type == "statesUS"){
      filters.statesUS = value.map(stateUS => stateUS.value)
    }
    else if (type == "cities"){
      filters.cities = value.map(cities => cities.value)
    }
    filters = {"states":filters.states,"lastLogin":filters.lastLogin,"primaryInterests":filters.primaryInterests,"interests":filters.interests,"genders":filters.genders,"ages":filters.ages,"referred":filters.referred,"followers":filters.followers,"followersNone":filters.followersNone,"engagementRate":filters.engagementRate,"search":filters.search,"countries":filters.countries,"counties":filters.counties,"statesUS":filters.statesUS,"cities":filters.cities,"ratings":filters.ratings}
    setInfluencerFilters(Object.assign({},influencerFilters, filters));
    setFilter(filters,"influencer")
  }

  const updateNotificationData = (id,value) => {
    var tempNotificationModal = structuredClone(notificationModal)
    tempNotificationModal[id] = value
    setNotificationModal(tempNotificationModal)
  } 

  const sendNotification = async () => {
    var response = await apiCall(`notification/custom`,{ "method" : "POST", "data" : {"type":"influencer","target":notificationModal.target,"details":{"customTargets":notificationModal.customTargets.map(target => target.value),"message":{"title":notificationModal.title,"body":notificationModal.message},"filters":influencerFilters}} });
    if (response["success"]){
      setAlert({"display":"toast","visible":true,"title":"Notification Sent","content":"The notification was successfully sent to the targets specified","className":"bg-success text-background"})
      setNotificationModal({"visible":false,"title":"","message":"","target":"All","customTargets":[]})
    }
    else {
      setAlert({"display":"toast","visible":true,"title":"Failed to send notification","content":response["failure"]["error"],"className":"bg-danger text-background"})
    }
  }

  const getInfluencerCities = async (cityInput) => {
    var response = await apiCall(`influencers/cities?cityInput=${cityInput}`,{ "method" : "GET" });
    if (response["success"]){
      return response["success"]["cities"]
    }
  }

  const getInfluencerCountries = async (cityInput) => {
    var response = await apiCall(`influencers/countries?countryInput=${cityInput}`,{ "method" : "GET" });
    if (response["success"]){
      return response["success"]["countries"]
    }
  }

  const setState = async (event,result) => { 
    result = await result;
    if (event.pageData.page >= 1) {
        for (var x in result["influencers"]) {
            influencers.push(result["influencers"][x])  
        }
        setInfluencers(influencers)
    } else {
      setInfluencers(result["influencers"])
    }
    setPageStats(result["_paging"])
  }

  return (
    <div className="bg-page influencers">
    <Topbar />
    <div className="pageName">Members</div>
    <Container id="applicant-list-container" className="fullscreenWithTopBar top-0" fluid>
      <AlertModal modal={showAlert} onClose={() => setAlert({"display":"toast","visible":false,"title":"","content":""})} />
      <Row>
        <AdminNav />
        <div className="col-xl-12 col-xxl-10 px-0">
          <div className="ps-4 py-3 py-xl-4 pe-0 bg-background shadow-sm">
            <div className="d-flex align-items-center justify-content-between mb-lg-4 ms-xl-4">
              <h1 className="pageTitle text-nowrap text-primary secondaryHeadingsFont fw-700 mb-0 fs-3">Members</h1>
              <div className="form-group d-flex">
                {currentProfile.type == "admins" && <>
                  <Button variant="outline-primary" size="sm" className="text-nowrap me-2 me-md-3" onClick={() => setNotificationModal({"visible":true,"title":"","message":"","target":"All","customTargets":[]})}>Notify <span className='d-none d-sm-inline'>Members</span></Button>
                  <Button variant="outline-primary" size="sm" className="text-nowrap me-2 me-md-3" onClick={() => setShowNewInfluencerModal(true)}>Add <span className='d-none d-sm-inline'>Member</span></Button>
                  <Button variant="outline-primary" disabled={activeButton == "downloadInfluencers"} size="sm" className="desktopFlex text-nowrap me-2 me-md-3" onClick={() => downloadInfluencers()}>Download</Button>
                </>}
                <InputGroup size="sm" className="me-3 d-none d-md-flex">
                  <Form.Control placeholder="Search" className="border-end-0 form-control-sm" aria-label="Search" defaultValue={influencerFilters.search} onChange={e => handleFilterUpdate(e,true,"search",500)}/>
                  <InputGroup.Text className="bg-background border-end">
                    <a><img src={searchBlue} /></a>
                  </InputGroup.Text>
                </InputGroup>
                <div className="bg-gray pb-1 pt-1 ps-2 pe-3 rounded-start text-nowrap pageDataCount">
                  <span className="fw-500 me-1">Total: </span><span> {pageStats.total} Members</span>
                  </div>
                </div>
              </div>
              <div className="desktopFlex align-items-center mx-xl-4 filters">
                <div className="fw-500 me-2 smaller">Filter:</div>
                <div className="form-group me-2">
                  <DropdownButton size="sm" variant="light" title="Account Status">
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.states.includes(true)} onChange={(e) => handleFilterUpdate(true,e.target.checked,"states")} />
                      <label title="" className="form-check-label">Active</label>
                    </div>
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.states.includes(false)} onChange={(e) => handleFilterUpdate(false,e.target.checked,"states")} />
                      <label title="" className="form-check-label">Disabled</label>
                    </div>
                  </DropdownButton>
                </div>
                <div className="form-group me-2">
                  <DropdownButton size="sm" variant="light" title="Last Login">
                    {[{label: "Last Hour", value: 3600}, {label: "Last Day", value: 86400}, {label: "Last Week", value: 604800}, {label: "Last Month", value: 2628000}, {label: "Last Year", value: 31536000}].map(timeDuration => (
                      <div key={timeDuration.value} className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                        <input type="radio" className="form-check-input me-2 mb-2" checked={influencerFilters.lastLogin === timeDuration.value} onChange={(e) => handleFilterUpdate(timeDuration.value,e.target.checked,"lastLogin")} />
                        <label title="" className="form-check-label">{timeDuration.label}</label>
                      </div>
                    ))}
                  </DropdownButton>
                </div>
                <div className="form-group me-2">
                  <DropdownButton size="sm" variant="light" title="Primary Interests">
                    {interests.map(interest => (
                      <div key={interest.value} className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                        <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.primaryInterests.includes(interest.value)} onChange={(e) => handleFilterUpdate(interest.value,e.target.checked,"primaryInterests")} />
                        <label title="" className="form-check-label">{interest.label}</label>
                      </div>
                    ))}
                  </DropdownButton>
                </div>
                <div className="form-group me-2">
                  <DropdownButton size="sm" variant="light" title="Categories/Interests">
                    {interests.map(interest => (
                      <div key={interest.value} className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                        <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.interests.includes(interest.value)} onChange={(e) => handleFilterUpdate(interest.value,e.target.checked,"interests")} />
                        <label title="" className="form-check-label">{interest.label}</label>
                      </div>
                    ))}
                  </DropdownButton>
                </div>
                <div className="form-group me-2">
                  <DropdownButton size="sm" variant="light" title="Age">
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.ages.includes("18-24")} onChange={(e) => handleFilterUpdate("18-24",e.target.checked,"ages")} />
                      <label title="" className="form-check-label">18 - 24</label>
                    </div>
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.ages.includes("25-34")} onChange={(e) => handleFilterUpdate("25-34",e.target.checked,"ages")} />
                      <label title="" className="form-check-label">25 - 34</label>
                    </div>
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.ages.includes("35-44")} onChange={(e) => handleFilterUpdate("35-44",e.target.checked,"ages")} />
                      <label title="" className="form-check-label">35 - 44</label>
                    </div>
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.ages.includes("45-59")} onChange={(e) => handleFilterUpdate("45-59",e.target.checked,"ages")} />
                      <label title="" className="form-check-label">45 - 59</label>
                    </div>
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.ages.includes("60-125")} onChange={(e) => handleFilterUpdate("60-125",e.target.checked,"ages")} />
                      <label title="" className="form-check-label">60+</label>
                    </div>
                  </DropdownButton>
                </div>
                <div className="form-group me-2">
                  <DropdownButton size="sm" variant="light" title="Gender">
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.genders.includes("Male")} onChange={(e) => handleFilterUpdate("Male",e.target.checked,"genders")} />
                      <label title="" className="form-check-label">Male</label>
                    </div>
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.genders.includes("Female")} onChange={(e) => handleFilterUpdate("Female",e.target.checked,"genders")} />
                      <label title="" className="form-check-label">Female</label>
                    </div>
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.genders.includes("Other")} onChange={(e) => handleFilterUpdate("Other",e.target.checked,"genders")} />
                      <label title="" className="form-check-label">Other</label>
                    </div>
                  </DropdownButton>
                </div>

                <div className="form-group me-2">
                  <DropdownButton size="sm" variant="light" title="Referred">
                  <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.referred.includes(true)} onChange={(e) => handleFilterUpdate(true,e.target.checked,"referred")} />
                      <label title="" className="form-check-label">Yes</label>
                    </div>
                    <div className="form-check d-flex align-items-center mx-3 mt-1 text-nowrap">
                      <input type="checkbox" className="form-check-input me-2 mb-2" checked={influencerFilters.referred.includes(false)} onChange={(e) => handleFilterUpdate(false,e.target.checked,"referred")} />
                      <label title="" className="form-check-label">No</label>
                    </div>
                  </DropdownButton>
                </div>
                <div className="form-group me-2">
                  <DropdownButton size="sm" className="customHeaderMultiSelect" variant="light" title={influencerFilters.cities.length == 0 ? "All Cities" : `${influencerFilters.cities.length} Cit${influencerFilters.cities.length == 1 ? "y" : "ies"}`}>
                  <AsyncSelect 
                    isMulti
                    cacheOptions
                    defaultOptions
                    placeholder="Cities"
                    controlShouldRenderValue={false}
                    closeMenuOnSelect={false}
                    loadOptions={getInfluencerCities}
                    onChange={(choice) => handleFilterUpdate(choice, null, "cities")}
                  />
                  </DropdownButton>
                </div>
                <div className="form-group me-2">
                  <DropdownButton size="sm" className="customHeaderMultiSelect" variant="light" title={influencerFilters.countries.length == 0 ? "All Countries" : `${influencerFilters.countries.length} Countr${influencerFilters.countries.length == 1 ? "y" : "ies"}`}>
                  <Select
                    isMulti
                    placeholder="Countries"
                    controlShouldRenderValue={false}
                    closeMenuOnSelect={false}
                    options={countries}
                    onChange={(choice) => handleFilterUpdate(choice, null, "countries")}
                  />
                  </DropdownButton>
                </div>
                {influencerFilters.countries.includes("GB") &&
                  <div className="form-group me-2">
                    <DropdownButton size="sm" className="customHeaderMultiSelect" variant="light" title={influencerFilters.counties.length == 0 ? "All Counties" : `${influencerFilters.counties.length} Count${influencerFilters.counties.length == 1 ? "y" : "ies"}`}>
                      <Select
                          placeholder="County"
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          controlShouldRenderValue={false}
                          defaultValue={[]}
                          menuIsOpen
                          options={counties} 
                          id="county" 
                          isMulti
                          onChange={(choice) => handleFilterUpdate(choice, null, "counties")}
                      />
                    </DropdownButton>
                  </div>
                }
                {influencerFilters.countries.includes("US") &&
                  <div className="form-group me-2">
                    <DropdownButton size="sm" className="customHeaderMultiSelect" variant="light" title={influencerFilters.statesUS.length == 0 ? "All States" : `${influencerFilters.statesUS.length} State${influencerFilters.statesUS.length > 1 ? "s" : ""}`}>
                      <Select
                          placeholder="State"
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          controlShouldRenderValue={false}
                          defaultValue={[]}
                          menuIsOpen
                          options={statesUS} 
                          id="stateUS"
                          isMulti
                          onChange={(choice) => handleFilterUpdate(choice, null, "statesUS")}
                      />
                    </DropdownButton>
                  </div>
                }
                <a className="text-danger small" onClick={(e) => handleFilterUpdate(null,null,"reset")}><u>Reset</u></a>
              </div>
            </div>

            {showNewInfluencerModal && (
              <Modal show backdrop="static" centered size="lg" >
              <Modal.Header className="pe-4">
                <Modal.Title className="h5">
                  Add New Member
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="pb-0">
                <Row>
                  <Col xs={12} sm={12} md={6}>
                      <Form.Group className="mb-3">
                          <Form.Label className="mb-1">First Name <span className="text-danger">*</span></Form.Label>
                          <Form.Control type="name" className="" id="firstName" value={newInfluencerData.firstName} onChange={(e) => updateNewInfluencerData(e)} />
                      </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                      <Form.Group className="mb-3">
                          <Form.Label className="mb-1">Last Name <span className="text-danger">*</span></Form.Label>
                          <Form.Control type="name" className="" id="lastName" value={newInfluencerData.lastName} onChange={(e) => updateNewInfluencerData(e)} />
                      </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                      <Form.Group className="mb-3">
                          <Form.Label className="mb-1">Gender <span className="text-danger">*</span></Form.Label>
                          <Form.Select className="" id="gender" onChange={(e) => updateNewInfluencerData(e)} >
                            <option selected={newInfluencerData.gender == "Male"}>Male</option>
                            <option selected={newInfluencerData.gender == "Female"}>Female</option>
                            <option selected={newInfluencerData.gender == "Prefer not to say"}>Prefer not to say</option>
                            <option selected={newInfluencerData.gender == "Prefer to self-describe (please specify)"}>Prefer to self-describe (please specify)</option>
                          </Form.Select>
                      </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                      <Form.Group className="mb-3">
                          <Form.Label className="mb-1">	Date of Birth	<span className="text-danger">*</span></Form.Label>
                          <Form.Control type="date" className="" id="dob" onChange={(e) => updateNewInfluencerData(e)} />
                      </Form.Group>
                  </Col>
                  {specifyGender && (
                  <Col xs={12} sm={12} md={6}>
                      <Form.Group className="mb-3">
                          <Form.Label className="mb-1">Specify Gender <span className="text-danger">*</span></Form.Label>
                          <Form.Control type="gender" className="" id="specificGender" value={newInfluencerData.specificGender} onChange={(e) => updateNewInfluencerData(e)} />
                      </Form.Group>
                  </Col>
                  )}
                  <Col xs={12} sm={12} md={12}>
                      <Form.Group className="mb-3">
                          <Form.Label className="mb-1">Email <span className="text-danger">*</span></Form.Label>
                          <Form.Control type="email" className="" id="email" value={newInfluencerData.email} onChange={(e) => updateNewInfluencerData(e)} />
                      </Form.Group>
                  </Col>
        
                  <Col xs={12} sm={12} md={6} className="mb-3">
                    <label>Primary Interest</label>
                      <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={[]}
                          options={interests} 
                          id="primaryInterest" 
                          onChange={ (choice) => updateNewInfluencerData({"target":{"value":choice.value,"id":"primaryInterest"}}) } 
                      />
                  </Col>
                  <Col xs={12} sm={12} md={6} className="mb-3">
                    <label>Interests</label>
                      <Select
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          defaultValue={[]}
                          options={interests}
                          isMulti
                          id="interests" 
                          onChange={ (choice) => updateNewInfluencerData({"target":{"value":choice.map(item => item.value),"id":"interests"}}) } 
                      />
                  </Col>
                  <Col xs={12} sm={12} md={6} className="mb-3">
                    <label>Country</label>
                      <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={[]}
                          options={countries} 
                          id="country" 
                          onChange={ (choice) => updateNewInfluencerData({"target":{"value":choice.value,"id":"country"}}) } 
                      />
                  </Col>        
        

                  <Row>
                    <Col>
                      <div className='form-group mb-3'>
                        <label>
                          <input type="checkbox" className="form-check-input me-1" id="createUser" checked={newInfluencerData.createUser} onChange={(e) => updateNewInfluencerData({"target":{"value":e.target.checked,"id":e.target.id}})} /> Create User</label>
                      </div>
                      </Col>
                  </Row>

                  {newInfluencerData.createUser && (
                    <>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                  <input type="checkbox" className="form-check-input me-1" id="sendPasswordReset" checked={newInfluencerData.sendPasswordReset} onChange={(e) => updateNewInfluencerData({"target":{"value":e.target.checked,"id":e.target.id}})} /> Send Password Reset</Form.Label>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        {!newInfluencerData.sendPasswordReset && (<>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-1">New Password</Form.Label>
                                    <Form.Control type="password" id="password" value={newInfluencerData.password} onChange={(e) => updateNewInfluencerData(e)} className="" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-1">Confirm Password</Form.Label>
                                    <Form.Control type="password" id="passwordConfirm" value={newInfluencerData.passwordConfirm} onChange={(e) => updateNewInfluencerData(e)} className="" />
                                </Form.Group>
                            </Col>
                        </>)}
                    </Row>
                    </>
                  )}
        
                </Row>
              </Modal.Body>
              <Modal.Footer className="border-0 pt-0">
                <Button variant="outline-secondary" size="sm" onClick={()=>{setShowNewInfluencerModal(false);  setNewInfluencerData({"interests":"","primaryInterest":"","gender":"","phoneNumber":"","country":"","email":"","active":true,"sendPasswordReset":true,"createUser":false,"password":"","passwordConfirm":"","firstName":"","lastName":""})}}>Cancel</Button>
                <Button disabled={(newInfluencerData.password != newInfluencerData.passwordConfirm && !newInfluencerData.sendPasswordReset) || ["name","industry"].filter(function(field) {return newInfluencerData[field] == ""}).length > 0 || newInfluencerData.password == "" && !newInfluencerData.sendPasswordReset} onClick={() => submitNewInfluencer()} variant="success" size="sm">Submit</Button>
              </Modal.Footer>
            </Modal>
            )}

            {notificationModal.visible && (
              <Modal show backdrop="static" centered size="lg" >
              <Modal.Header className="pe-4">
                <Modal.Title className="h5">
                  Send Custom Notification
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="pb-0">
                <p>Send a notification to selected members.</p>
                <div className="form-group mb-4 notificationTargets">              
                  <ToggleButtonGroup type="radio" name="toggle" value={notificationModal.target} onChange={e => updateNotificationData("target",e)} id="notificationTargetType">
                    <ToggleButton id="notificationTargetType-1" className="me-2 mb-2" value="All">All</ToggleButton>
                    <ToggleButton id="notificationTargetType-9" className="me-2 mb-2" value="Custom">Custom</ToggleButton>
                  </ToggleButtonGroup>
                  {notificationModal.target == "Custom" && 
                    <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        value={notificationModal.customTargets}
                        options={influencers.map(influencer => ({"label":`${influencer.name} (${influencer.email})`,"value":influencer._id}))} 
                        id="customNotificationTargets" 
                        onChange={ (choice) => {updateNotificationData("customTargets",choice)} } 
                      />
                  }
                  <span className="small text-muted d-block mb-3">Select all members from or choose specific members</span>  
                </div>
                <div className="form-group my-4 position-relative">
                    <input type="text" maxLength="50" className="form-control pe-5" value={notificationModal.title} onChange={e => updateNotificationData("title",e.target.value)} id="title" placeholder="Write your message here"></input>
                </div>
                <div className="form-group my-4 position-relative">
                    <textarea type="text" rows="6" maxLength="500" className="form-control pe-5" value={notificationModal.body} onChange={e => updateNotificationData("message",e.target.value)} id="body" placeholder="Write a longer description for users to read once they've clicked on the notification"></textarea>
                </div>
              </Modal.Body>
              <Modal.Footer className="border-0 pt-0">
                <Button variant="outline-secondary" size="sm" onClick={() => setNotificationModal({"visible":false,"title":"","message":"","target":"All","customTargets":[]})}>Cancel</Button>
                <Button disabled={notificationModal.message.length == 0 || (notificationModal.target == "Custom" && notificationModal.customTargets.length == 0)} onClick={() => sendNotification()} variant="success" size="sm">Send</Button>
              </Modal.Footer>
            </Modal>
            )}

            { !isLoaded ? <FullPageSpinner /> : (     
              <div className="p-4 pt-0 influencersTable mt-2 mt-xl-4 pb-0">
                <div className="mx-xl-4">
                  <div className="tableHeaderFixedBelt"></div>
                  <Table className="border-transparent">
                    <thead>
                      <tr>
                        <th>Profile</th>
                        <th>Categories</th>
                        <th className="d-none">Referred by</th>
                        <th>Last Login</th>
                        <th className="text-center">Country</th>
                        <th>Log in as user</th>
                      </tr>
                    </thead>
                    <tbody className="small">
                      {influencers.map(influencer => (
                        <tr key={influencer._id}>
                          <td>
                            <div className="d-flex">
                              <img src={getImageUrl(providers,influencer.profileImage,["w_80","c_scale"])} height="44px" width="44px" className="object-fit-cover rounded me-2 border" />
                              <div>
                                <h6 className="mb-1">{influencer.name}</h6>
                                <div className="influencerInfo">
                                  {influencer.active ? <Badge pill bg="success" text="dark" className="me-2">Active</Badge> : <Badge pill bg="danger" text="dark" className="me-2">Disabled</Badge>}
                                  {currentProfile.type == "admins" && getRatingPill(influencer.rating) }
                                  <span className="small me-2">{getAge(influencer.dob)} years old</span>
                                  <span className="small">{influencer.gender}</span>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="mb-2">
                                <div className="mb-1 tagsTitle">Primary Category:</div>
                                <span className="tags text-nowrap">{influencer.interests[0]}</span>
                            </div>
                            <div>
                                <div className="mb-1 tagsTitle">Interests:</div>
                                {influencer.interests.length <= 3 ? 
                                (
                                  <>
                                  {influencer.interests.map(interest => (<span key={interest} className="tags me-1 text-nowrap">{interest}</span>))}
                                  </>
                                ) :
                                  <>
                                  {influencer.interests.slice(1,3).map(interest => (<span key={interest} className="tags me-1 text-nowrap">{interest}</span>))}
                                  <span className="tags fw-bold cursor-pointer">+{influencer.interests.length - 2}</span>
                                  </>
                                }
                            </div>
                          </td>
                          <td className="d-none"><span className="tags text-nowrap">{influencer.referrer ? influencer.referrer : "N/A"}</span></td>
                          <td><span className="text-nowrap">{influencer.lastLogin ? (new Date(influencer.lastLogin*1000)).toLocaleDateString('en-GB', { year:"numeric", month:"short", day:"numeric", hour:"2-digit", minute:"2-digit"}) : "Never"}</span></td>
                          <td align="center"><img src={`https://hatscripts.github.io/circle-flags/flags/${influencer.country.toLowerCase()}.svg`} className="border rounded-circle me-2" width="26px" /></td>
                          <td>
                            <div className="d-flex align-items-center justify-content-between">
                              <button type="button" disabled={!influencer.active || activeButton == "impersonate"} onClick={e => loginAsInfluencer(influencer._id)} className="btn btn-sm btn-outline-primary">Login</button>
                              <Dropdown className="brandAction">
                                <Dropdown.Toggle variant="default" className="border-0">
                                  <img src={settings} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                <Link to={`/Administration/Influencers/Settings?id=${influencer._id}`} className="dropdown-item">Edit</Link>
                                {currentProfile.type == "admins" && <>{ influencer.active ? <Link className="dropdown-item" onClick={e => disableInfluencer(influencer._id)}>Disable</Link> : <Link className="dropdown-item" onClick={e => enableInfluencer(influencer._id)}>Enable</Link> }</>}
                              </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                <PageScroller endpoint="influencers" setState={setState} filter={influencerFilters} pageSize={100} />
              </div>
            )}
          </div>
        </Row>
      </Container>
    </div>
  );
}